import { useIsGuest } from "@/hooks/useIsGuest";
import { LoginForm } from "@/components/Auth/Login.form";
import { useHeaderContext } from "@/hooks/useHeaderContext";
import { useEffect } from "react";
import { LoginHeader } from "@/components/Page/Header/LoginHeader";

const LoginPage = () => {
  useIsGuest();
  const { setHeaderContent } = useHeaderContext();

  useEffect(() => {
    setHeaderContent(<LoginHeader />);

    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  return (
    <div className="m-auto flex flex-col gap-4 bg-slate-900 text-slate-100">
      <LoginForm />
    </div>
  );
};

export default LoginPage;
